export default "__VITE_ASSET__26b44427__"